import { render, staticRenderFns } from "./savanha-wines.vue?vue&type=template&id=2ad40f4f&scoped=true"
import script from "./savanha-wines.vue?vue&type=script&lang=js"
export * from "./savanha-wines.vue?vue&type=script&lang=js"
import style0 from "./savanha-wines.vue?vue&type=style&index=0&id=2ad40f4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad40f4f",
  null
  
)

export default component.exports